"use client";

import React, { useState } from "react";
import * as Collapsible from "@radix-ui/react-collapsible";
import CheckIcon from "@/assets/icons/Check.svg";
import ClockIcon from "@/assets/icons/clock.svg";
import ExpandIcon from "@/assets/svg/expand.svg";
import { PricingPlanKey, toDataQaSlug } from "./types";

export type PricingCardData = {
  key: PricingPlanKey;
  title: string;
  price: string;
  fromLabel: string;
  timeline: string;
  details: string;
  features: string[];
};

type PricingCardMobileProps = {
  plan: PricingCardData;
};

const PricingCardMobile: React.FC<PricingCardMobileProps> = ({ plan }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Collapsible.Root
      className="PricingBlock__card PricingBlock__card--mobile"
      data-state={isOpen ? "open" : "closed"}
      open={isOpen}
      onOpenChange={setIsOpen}>
      <Collapsible.Trigger
        className="PricingBlock__mobileTrigger"
        data-qa={`pricing-card-mobile-toggle-${toDataQaSlug(plan.title)}`}
        aria-controls={`pricing-card-mobile-content-${plan.key}`}>
        <div className="PricingBlock__mobileHeader">
          <span className="PricingBlock__plan PricingBlock__plan--mobile">{plan.title}</span>
          <span
            className="PricingBlock__chevron"
            aria-hidden>
            <ExpandIcon />
          </span>
        </div>
        <div className="PricingBlock__mobileSummary">
          <p className="PricingBlock__priceRow">
            <span className="PricingBlock__from">{plan.fromLabel}</span>
            <span className="PricingBlock__price">{plan.price}</span>
          </p>
          <p className="PricingBlock__timeline">
            <span
              className="PricingBlock__timelineIcon"
              aria-hidden>
              <ClockIcon />
            </span>
            <span className="PricingBlock__timelineText">{plan.timeline}</span>
          </p>
        </div>
      </Collapsible.Trigger>

      <Collapsible.Content className="PricingBlock__mobileContent">
        <p className="PricingBlock__details">{plan.details}</p>
        <span className="PricingBlock__srOnly">{`${plan.title} details`}</span>
        <div
          id={`pricing-card-mobile-content-${plan.key}`}
          data-qa={`pricing-card-mobile-content-${toDataQaSlug(plan.title)}`}>
          <ul className="PricingBlock__features">
            {plan.features.map((feature, index) => (
              <li
                className="PricingBlock__feature"
                key={`${plan.key}-${index}`}>
                <span
                  className="PricingBlock__check"
                  aria-hidden>
                  <CheckIcon />
                </span>
                <span className="PricingBlock__featureText">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};

export default PricingCardMobile;
